import initialState from './initialState'
import {
    SET_APP_CAPTCHA
} from '../constants/actionTypes'


export default (state = initialState, action) => {
    switch (action.type) {
        case SET_APP_CAPTCHA:
            return {
                ...state,
                token: action.token
            }


        default:
            return state
    }
}
